module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978 1 52674 971 0")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("eISBN 978 1 52674 972 7")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Mobi ISBN 978 1 52674 973 4")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published in 2019 by Pen & Sword Transport")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("an imprint of Pen & Sword Books Ltd, 47 Church Street,")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Barnsley, South Yorkshire, S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © Matthew Wharmby, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The right of Matthew Wharmby to be identified as the Author")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("of this Work has been asserted by them in accordance with the")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Copyright, Designs and Patents Act 1988. A CIP catalogue record")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("for this book is available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("or transmitted in any form or by any means, electronic or")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("mechanical including photocopying, recording or by any")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("information storage and retrieval system, without permission")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the imprints of Pen &")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Sword Archaeology, Atlas, Aviation, Battleground, Discovery,")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Family History, History, Maritime, Military, Naval, Politics,")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Railways, Select, Transport, True Crime, and Fiction, Frontline")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Books, Leo Cooper, Praetorian Press, Seaforth Publishing and")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("Wharncliffe.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("PEN & SWORD BOOKS LIMITED")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS,")]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("England")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_vm._v("enquiries@pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy_"
  }, [_vm._v("website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk ",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pbk"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyy"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Front cover:")]), _vm._v(" Stagecoach East")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("London "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("T 163")]), _vm._v(" (CUL 163V)")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("at Romford, 21 April 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "copyy"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Back cover, top:")]), _vm._v(" Blue Triangle")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("T 349")]), _vm._v(" (KYV 349X) at Croydon,")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("29 August 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "copyy"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Back cover, middle:")]), _vm._v(" London")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("Central "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("T 1111")]), _vm._v(" (B111 WUV) at")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("Crystal Palace, 11 August 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "copyy"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Back cover, bottom:")]), _vm._v(" Stagecoach")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("Selkent "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("T 885")]), _vm._v(" (A885 SUL) at")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("Bromley South, 22 April 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "copyy"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Title page:")]), _vm._v(" London Central "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("T 787")])]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("(OHV 787Y) at Bexleyheath,")]), _vm._v(" "), _c('p', {
    staticClass: "copySS"
  }, [_vm._v("20 March 1999.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0